import actionTypes from '../constants/actionTypes/error-action-types';

export const cleanError = () => ({
    type: actionTypes.CLEAN
});

export const setGlobalError = (message: string) => ({
    type: actionTypes.SET,
    payload: message
});
